import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import { openCreateNewWallPopup } from '../../../../../actions/wallsAction';
import { closePricingModal } from '../../../../../utils/close_modal';
import { getWidgetWallData } from '../../../../../actions/wallDataAction';
import { getInitialRoute } from '../../../../../utils';
import { USER_STUDIO_WALL } from '../../../../../actions/sceneActions';
import { toggleAddFeedsSection_D } from '../../../../../actions/showDisplayModalAction';
import { getUserTags } from '../../../../../actions/loginActions';
import { FontAwesomeIcon } from '../../../../CommonComponents/AssetsHelper';
import { GET_FEEDS } from '../../../../../actions/manageFeedsAction';

function WallSwitcher({ userfeeds, prefix, UserPlan }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedWall, setSelectedWall] = useState(
    userfeeds ? userfeeds[0] : null
  );
  const ownerId = parseInt(localStorage.getItem("ownerId"));

  const addAnotherWidget = useCallback(() => {
    navigate(`/walls`);
    closePricingModal(dispatch);
    dispatch(openCreateNewWallPopup(true));
  }, []);


  const selectOtherWidget = useCallback((widget, feedCount) => {
    const path = window.location.pathname;
    setSelectedWall(widget);
    closePricingModal(dispatch);

    localStorage.setItem('wallId', widget.wall.id);
    if (!path.includes("/moderation")) {
      dispatch(getWidgetWallData(ownerId, widget.wall.id));
    }

    if (feedCount == 0 && (path.includes("/wall/index"))) {
      const route = `/wall/index/${widget.wall.id}`;
      dispatch(toggleAddFeedsSection_D(true, route, navigate));

    } else {
      if (path.includes("/moderation")) {
        dispatch(getUserTags(ownerId, widget.wall.id));
        dispatch(GET_FEEDS())
        navigate(`/moderation/index/${widget.wall.id}`);
      } else if (path.includes('analytic')) {
        navigate(`/analytic/${widget.wall.id}`);
      } else if (path.includes("/preview")) {
        navigate(`/wall/preview/${widget.wall.id}`);
      } else if (path.includes("/personalize")) {
        navigate(`/wall/personalize/${widget.wall.id}`);
      } else if (path.includes("/studio")) {
        dispatch(USER_STUDIO_WALL(widget.wall.id));
        setTimeout(() => navigate(`/studio/${widget.wall.id}`), 100);
      } else {
        navigate(`/wall/index/${widget.wall.id}`);
      }
    }

  }, []);

  useEffect(() => {
    const wallid = localStorage.getItem("wallId");
    const sWall = userfeeds.find((item) => `${item.wall.id}` === wallid);
    setSelectedWall(sWall);
  }, [userfeeds]);

  return (
    <>
      {selectedWall ? (
        <div className="wall_switcher px-2 py-3">
          <Dropdown className="">
            <Dropdown.Toggle variant="" id="wallswitcherDropdownMenu" className="d-flex border position-relative wall-switcher-box p-0 border-light w-100 btn-primary arrow_disabled">
              <div className="wall-switcher f-between bg-white p-1 w-100 text-dark">
                <div className="d-flex wall-switcher-item overflow-hidden">
                  <div className="switcher-thumbnail symbol-35 f-center rounded fs-5 text-dark fw-medium me-2">
                    <span className="text-uppercase"> {selectedWall.wall.name[0]} </span>
                  </div>
                  <div className="switcher-details d-flex flex-column flex-grow-1 overflow-hidden w-100 justify-content-start">
                    <p className="m-0 text-dark text-truncate text-start"> {selectedWall.wall.name} </p>
                    <span className='text-truncate text-secondary fs-6 text-start d-block lh-1'> <small>{selectedWall.postCount ? `${selectedWall.postCount <= 1 ? `${selectedWall.postCount} Post` : `${selectedWall.postCount} Posts`}` : `0 Post`}</small> </span>
                  </div>
                </div>
                <FontAwesomeIcon type={'regular'} icon={'angle-right'} iconClass={'menu-arrow me-2'} />
              </div>
            </Dropdown.Toggle>

            {
              userfeeds && userfeeds.length > 0 ? <Dropdown.Menu className="w-100 p-0">
                <div className="wall-switcher-list p-2 m-0 w-100 border-bottom overflow-y-auto overflow-x-hidden">
                  {
                    userfeeds && userfeeds.map((widget) => (
                      <Dropdown.Item className={`wall-switcher border-bottom px-0 py-2 overflow-hidden ${selectedWall.wall.id === widget.wall.id ? 'activeWall' : ''}`} key={widget.wall.id} onClick={() => selectOtherWidget(widget, widget.feeds.length)}>
                        <div className="d-flex align-items-center w-100">
                          <div className="switcher-thumbnail symbol-35 f-center rounded fs-5 text-dark fw-medium me-2"> <span>{widget.wall.name[0] ? widget.wall.name[0].toUpperCase() : ""}</span> </div>
                          <div className="switcher-details d-flex flex-column flex-grow-1 overflow-hidden w-100 justify-content-start">
                            <p className="m-0 text-dark text-truncate text-start fw-medium">{widget.wall.name}</p>
                            <span className='text-truncate fs-6 text-start d-block lh-1'><small>{widget.postCount ? `${widget.postCount <= 1 ? `${widget.postCount} Post` : `${widget.postCount} Posts`}` : `0 Post`}</small></span>
                          </div>
                          <span className={`ms-2 ${selectedWall.wall.id === widget.wall.id ? 'd-block' : 'd-none'}`}>
                            <FontAwesomeIcon type={'solid'} icon={'badge-check'} iconClass={'fs-5 text-success'} />
                          </span>
                        </div>
                      </Dropdown.Item>
                    ))}
                </div>
                {JSON.parse(localStorage.getItem('isCollaborator')) == 0 && <div className="p-2">
                  <Dropdown.Item className="btn-light rounded text-dark fw-medium" onClick={addAnotherWidget}>
                    <FontAwesomeIcon type={'solid'} icon={'plus'} />
                    <span className="ms-1">Add Another {getInitialRoute() == 'widget' ? 'Widget' : 'Wall'}</span>
                  </Dropdown.Item>
                </div>}
              </Dropdown.Menu> : null
            }
          </Dropdown>
        </div>) : null}</>)
}

export default React.memo(WallSwitcher);
